import { render, staticRenderFns } from "./ColorStop.vue?vue&type=template&id=1071ee15&scoped=true"
import script from "./ColorStop.vue?vue&type=script&lang=js"
export * from "./ColorStop.vue?vue&type=script&lang=js"
import style0 from "./ColorStop.vue?vue&type=style&index=0&id=1071ee15&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071ee15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1071ee15')) {
      api.createRecord('1071ee15', component.options)
    } else {
      api.reload('1071ee15', component.options)
    }
    module.hot.accept("./ColorStop.vue?vue&type=template&id=1071ee15&scoped=true", function () {
      api.rerender('1071ee15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ColorStop.vue"
export default component.exports